/**
 * Created by Rain Laansalu on 16.10.2017.
 */
import 'bootstrap';
import 'owl.carousel';
import 'bootstrap-autohide-navbar';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import '../src/main.scss';
import '../src/app.scss';

import '../src/js/constants';
import '../src/js/main';
import '../src/js/login';

$(document).ready(function () {
    $('[data-toggle="loginbtn"]').each(function (index, e) {
        $(this).on("click", function () {
            openlogin();
        });
    });

    $('[data-toggle="close_loginbtn"]').each(function (index, e) {
        $(this).on("click", function () {
            closelogin();
        });
    });

    $('[data-toggle="submitloginform"]').each(function (index, e) {
        $(this).on("click", function () {
            console.log(this);
        });
    });

    parallaxIt();


});


let autohide = undefined;
$(function () {
    'use strict';

    autohide = $('.navbar').bootstrapAutoHideNavbar({
        disableAutoHide: false,
        delta: 5,
        duration: 250,
        shadow: false
    });
});

// import '../src/avaleht.html';
// import 'src/app.css'

// makes the parallax elements
function parallaxIt() {
    var $contentObj = $('[data-type="content"]');
    if ($contentObj.length) {

        // create variables
        var $fwindow = $(window);
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // on window scroll event
        $fwindow.on('scroll resize', function () {
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        });


        var fgOffset = parseInt($contentObj.offset().top);
        var yPos;
        var offset = ($contentObj.data('offset') || 600 );

        $fwindow.on('scroll resize', function () {
            yPos = fgOffset - scrollTop - offset;
            $contentObj.css('top', yPos);
        });
        $fwindow.trigger('scroll');
    }
};

$('#owl-carousel1').owlCarousel({
    // move navContainer outside the primary owl wrapper
    // navContainer: '#customNav',
    // move dotsContainer outside the primary owl wrapper
    // dotsContainer: '#customDots',
    nav: true,
    startPosition: 1,
    dots: false,
    margin: 10,
    navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 3,
            stagePadding: 50,
        },
        1000: {
            items: 8,
            navText: ['<span class="carousel-control-prev-icon dark-arrow-left" aria-hidden="true"></span>', '<span class="carousel-control-next-icon dark-arrow-right" aria-hidden="true"></span>'],
        }
    }
});

$('#owl-carousel2').owlCarousel({
    stagePadding: 200,
    margin: 48,
    items: 3,
    lazyLoad: true,
    nav: true,
    dots: true,
    navContainer: '#customNav',
    // dotsContainer: '#customDots',
    navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
    responsive: {
        0: {
            items: 1,
            stagePadding: 0,
            margin: 10,
            navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
        },
        600: {
            items: 1,
            stagePadding: 80,
            margin: 24,
            navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
        },
        800: {
            items: 2,
            stagePadding: 20,
            margin: 24,
            navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
        },
        1000: {
            items: 2,
            stagePadding: 100,
            navText: ['<span class="carousel-control-prev-icon" aria-hidden="true"></span>', '<span class="carousel-control-next-icon" aria-hidden="true"></span>'],
        },
        1200: {
            items: 2,
            stagePadding: 100
        },
        1400: {
            items: 2,
            stagePadding: 100
        },
        1600: {
            items: 3,
            stagePadding: 0,
            navText: ['<span class="carousel-control-prev-icon dark-arrow-left" aria-hidden="true"></span>', '<span class="carousel-control-next-icon dark-arrow-right" aria-hidden="true"></span>'],
        },
        1800: {
            items: 3,
            stagePadding: 0,
            navText: ['<span class="carousel-control-prev-icon dark-arrow-left" aria-hidden="true"></span>', '<span class="carousel-control-next-icon dark-arrow-right" aria-hidden="true"></span>'],
        }
    }
});

function openlogin() {
    let obj = $('#login_div');
    if (obj.is(":visible")) {
        autohide.show();
        //do nothing
        // autohide.hide();
        // obj.slideUp();
    } else {
        autohide.show();
        obj.slideDown();
    }
}

function closelogin() {
    let obj = $('#login_div');
    if (obj.is(":visible")) {
        //do nothing
        // autohide.hide();
        obj.slideUp();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 3
// module chunks = 0